var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinnHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29391",
    "data-name": "Group 29391",
    transform: "translate(-86.999 -342.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(86.999 342.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-finn",
    transform: "translate(105.002 351.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50139",
    "data-name": "Path 50139",
    d: "M22.033,30.827V26.362A1.451,1.451,0,0,0,20.881,25c-.634,0-1.537,1.067-1.537,1.817v4.011ZM5,30.827V26.362A1.451,1.451,0,0,1,6.152,25c.634,0,1.537,1.067,1.537,1.817v4.011Z",
    transform: "translate(-5 -16.035)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50140",
    "data-name": "Path 50140",
    d: "M8.586,22.587v2h-3.3c-.036-.134-.067-.269-.094-.412h0A10.076,10.076,0,0,1,5,22.188C5,21.394,5.69,21,6.537,21S8.586,21.932,8.586,22.587Zm9.861,0v2h3.3c.036-.134.067-.269.094-.412h0a10.076,10.076,0,0,0,.193-1.986c0-.793-.69-1.188-1.537-1.188S18.447,21.932,18.447,22.587Z",
    transform: "translate(-5 -13.828)",
    fill: "#aed581"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50141",
    "data-name": "Path 50141",
    d: "M22.447,7.152v8.606H9V7.152A1.941,1.941,0,0,1,10.681,5a1.81,1.81,0,0,1,1.638,1.644,21.771,21.771,0,0,1,6.81,0A1.806,1.806,0,0,1,20.767,5,1.941,1.941,0,0,1,22.447,7.152Z",
    transform: "translate(-7.207 -5)",
    fill: "#e7ebed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50142",
    "data-name": "Path 50142",
    d: "M18.9,14.362c0,1.887-2.362,3.362-5.379,3.362s-5.379-1.475-5.379-3.362S10.5,11,13.517,11,18.9,12.475,18.9,14.362ZM5,23.1H6.793v2.69H5Zm15.24,0h1.793v2.69H20.24Z",
    transform: "translate(-5 -8.31)",
    fill: "#ffccbc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28947",
    "data-name": "Group 28947",
    transform: "translate(0.282 10.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50143",
    "data-name": "Path 50143",
    d: "M8.934,29v3.555a1.9,1.9,0,0,1-1.537-.4A6.039,6.039,0,0,1,5.63,29ZM18.8,29v3.555a1.9,1.9,0,0,0,1.537-.4A6.039,6.039,0,0,0,22.1,29Z",
    transform: "translate(-5.63 -29)",
    fill: "#7cb342"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28948",
    "data-name": "Group 28948",
    transform: "translate(4.931 4.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50144",
    "data-name": "Path 50144",
    d: "M22.724,15a.448.448,0,1,0,.448.448A.448.448,0,0,0,22.724,15Zm-6.275,0a.448.448,0,1,0,.448.448A.448.448,0,0,0,16.448,15Zm3.138,2.241a3.874,3.874,0,0,1-2.031-.517.448.448,0,1,1,.476-.759,3.374,3.374,0,0,0,3.11,0,.448.448,0,1,1,.476.76A3.878,3.878,0,0,1,19.586,17.241Z",
    transform: "translate(-16 -15)",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50145",
    "data-name": "Path 50145",
    d: "M22.447,26v8.069H9V26l.69.271a17.643,17.643,0,0,0,6.033.945,17.643,17.643,0,0,0,6.033-.945Z",
    transform: "translate(-7.207 -16.587)",
    fill: "#29b6f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinnHighlighted);
export default __webpack_public_path__ + "static/media/finnHighlighted.60bec3adecfd00ae122dbebc5ce25801.svg";
export { ForwardRef as ReactComponent };